import Chart from "chart.js"
import { Line, mixins } from "vue-chartjs"
import numeral from "numeral"

import profile_utilities from "../../mixins/ProfileUtilities"

Chart.Tooltip.positioners.bottom = (items) => {
    const pos = Chart.Tooltip.positioners.average(items)

    if(pos === false) return false
    console.log(pos)

    const chart = items[0]._chart
    return {
        x: pos.x,
        y: chart.chartArea.bottom
    }
}

export default Line.extend({
    mixins: [mixins.reactiveProp, profile_utilities],
    props: {
        chartData: {
            type: Array | Object,
            required: false
        },
        yMax: {
            type: Number,
            default: 0
        }
    },
    watch: {
        yMax: {
            handler (newOption, oldOption) {
                this._chart.destroy()
                this.renderChart(this.chartData, this.options)
            },
            deep: true
        }
    },
    computed: {
        annotations () {
            let annotations = []
            if(this.is_associate_principal || this.is_principal || this.is_developer || this.is_db_admin_active) {
                annotations = Object.keys(window.nibnut.vue.application_settings.load_lines).map(key => {
                    const value = window.nibnut.vue.application_settings.load_lines[key]
                    let color = "#27ae60"
                    if(key === "y") color = "#f2c94c"
                    else if(key === "z") color = "#e44e56"
                    return {
                        type: "line",
                        mode: "horizontal",
                        scaleID: "y-axis-0",
                        value,
                        borderColor: color,
                        borderWidth: 1,
                        label: {
                            backgroundColor: "transparent",
                            fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                            fontSize: 10,
                            fontStyle: "bold",
                            fontColor: color,
                            position: "left",
                            xPadding: 3,
                            yPadding: 3,
                            xAdjust: 0,
                            yAdjust: 8,
                            cornerRadius: 0,
                            enabled: true,
                            content: `${numeral(value).format("0,0")}%`
                        }
                    }
                })
            }
            return annotations
        },
        options () {
            return {
                layout: {
                    padding: 10
                },
                tooltips: {
                    mode: "index",
                    intersect: false,
                    position: "bottom",
                    itemSort: function (item_a, item_b) {
                        return item_b.yLabel - item_a.yLabel
                    },
                    callbacks: {
                        label: function (tooltipItem, data) {
                            return data.datasets[tooltipItem.datasetIndex].label + " " + numeral(tooltipItem.yLabel).format("0,0.0") + "%" + " (" + numeral(data.datasets[tooltipItem.datasetIndex].extra_data[tooltipItem.index]).format("0,0.0") + "h)"
                        }
                    }
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                                max: 250,
                                suggestedMax: this.yMax,
                                fontColor: "#00274F",
                                callback: function (value, index, values) {
                                    return numeral(value).format("0,0") + "%"
                                }
                            },
                            gridLines: {
                                display: true,
                                color: "rgba(0, 39, 79, 0.1)"
                            }
                        }/*,
                        {
                            position: "right",
                            offset: true,
                            ticks: {
                                beginAtZero: true,
                                max: 250,
                                suggestedMax: this.yMax,
                                fontColor: "#fff",
                                callback: function (value, index, values) {
                                    return "-----------"
                                }
                            },
                            gridLines: {
                                display: true,
                                color: "#fff"
                            }
                        }
                        */
                    ],
                    xAxes: [{
                        gridLines: {
                            display: false,
                            color: "rgba(0, 39, 79, 0.1)"
                        }
                    }]
                },
                legend: {
                    display: true,
                    position: "right", // "top"
                    labels: {
                        fontSize: 11,
                        // fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                        fontStyle: "bold",
                        fontColor: "#00274F",
                        boxWidth: 14,
                        padding: 13
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                annotation: {
                    drawTime: "beforeDatasetsDraw",
                    annotations: this.annotations
                }
            }
        }
    },
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
})
